import ReactGA from 'react-ga';
import ApiService from '../../Services/ApiService';

const googleAnalyticsTrackingId = window.__CONFIG__.GA_TRACKING_ID;

ReactGA.initialize(googleAnalyticsTrackingId);

function sendEvent(enrichedData) {
  if (enrichedData) {
    sendGAEvent(enrichedData);
    ApiService.eventTracking(enrichedData)
      .then((res) => {})
      .catch((err) => {});
  }
}

function sendGAEvent(enrichedData) {
  if (enrichedData) {
    ReactGA.set({
      userId: enrichedData.userId,
      orgId: enrichedData.orgId,
      idUtPipl: enrichedData.idUtPipl,
      email: enrichedData.email,
    });
    ReactGA.event({
      category: enrichedData.eventCategory || '',
      action: enrichedData.eventName || '',
      label: enrichedData.eventLabel || '',
      value: enrichedData.eventValue,
    });
  }
}

function buildEvent({ user, tracking, eventName, eventCategory, eventLabel, eventValue, eventData }) {
  if (!tracking.isEnabled) {
    return null;
  }
  return {
    eventName,
    eventCategory: eventCategory || 'ACCOUNTS_BI_EVENTS',
    eventLabel,
    eventValue,
    ...eventData,

    idUtPipl: tracking.idUtPipl,
    userId: user.userId,
    username: user.username,
    orgId: user.orgId,
  };
}

export default { sendEvent, buildEvent, sendGAEvent };
